






































































































































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import moment from "moment";
import AWS from "aws-sdk";
import uuid from "uuid";
import path from "path";
import LocationSearchModal from "@/components/LocationSearchModal.vue";
import Map from "@/components/Map.vue";
import { API_BASE_URL, S3_BUCKET, AWS_CREDENTIALS, COLOUR_OPTIONS, DATE } from "@/shared/global-values";
import IExpense from "@/types/expense";
import ILocation from "@/types/location";

export default Vue.extend({
  components: {
    LocationSearchModal,
    Map,
  },
  data() {
    return {
      id: this.$route.params.id,
      colourOptions: COLOUR_OPTIONS,
      expense: { location: {} } as IExpense,
      dateOptions: DATE,
      addedPhoto: false,
      isDisabled: false,
    };
  },
  computed: {
    isLocationSearchVisible(): boolean {
      return this.$store.getters.getIsLocationSearchVisible;
    },
  },
  async created(): Promise<void> {
    try {
      const token: string = await firebase.auth().currentUser!.getIdToken();
      const response: AxiosResponse = await axios.get(`${API_BASE_URL}/expenses/${this.id}`, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
      this.expense = response.data.expense as IExpense;

      if (!this.expense.location) {
        this.expense.location = {} as ILocation;
      }

      if (this.expense.photoURL) {
        this.addedPhoto = true;
        const photoPreview: HTMLImageElement = this.$refs.photoPreview as HTMLImageElement;
        photoPreview.setAttribute("src", this.expense.photoURL);
      }

      const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
      const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
      const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;

      const date: Date = new Date(this.expense.date);

      dateDay.value = date.getDate().toString();
      dateMonth.value = DATE.MONTHS[date.getMonth()];
      dateYear.value = date.getFullYear().toString();

    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    toggleLocationSearch(): void {
      this.$store.dispatch("toggleLocationSearch");
    },
    isSelectedColour(colour: string): boolean {
      return colour === this.expense.colour;
    },
    selectColour(event: Event): void {
      const span: HTMLSpanElement = event.currentTarget as HTMLSpanElement;
      this.expense.colour = span.dataset.colour as string;
    },
    selectLocation(location: ILocation): void {
      this.expense.location = location;
    },
    previewPhoto(event: Event): void {
      const input: HTMLInputElement = event.currentTarget as HTMLInputElement;
      const files: FileList | null = input.files;

      if (files) {
        const photo: File = files[0];
        this.addedPhoto = true;

        const fileReader: FileReader = new FileReader();
        fileReader.onload = (event: Event) => {
          const photoPreview: HTMLImageElement = this.$refs.photoPreview as HTMLImageElement;
          photoPreview.setAttribute("src", fileReader.result as string);
        };
        fileReader.readAsDataURL(photo);
      }
    },
    clearLocation(): void {
      this.expense.location.name = "";
    },
    clearPhoto(): void {
      const input: HTMLInputElement = document.getElementById("photo") as HTMLInputElement;
      input.value = "";
      this.addedPhoto = false;
      this.expense.photoURL = "";

      const photoPreview: HTMLImageElement = this.$refs.photoPreview as HTMLImageElement;
      photoPreview.removeAttribute("src");
    },
    async save(event: Event): Promise<void> {
      this.isDisabled = true;

      const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
      const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
      const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;
      const dateString: string = `${dateDay.value}-${dateMonth.value}-${dateYear.value}`;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);
      formData.set("date", moment(dateString, "D-MMMM-YYYY").toISOString());

      if (this.expense.location.name && this.expense.location.name !== "") {
        formData.set("location_name", this.expense.location.name);
        formData.set("location_address", this.expense.location.address);
        formData.set("latitude", this.expense.location.latitude as unknown as string);
        formData.set("longitude", this.expense.location.longitude as unknown as string);
      }

      try {
        const fileInput: HTMLInputElement = document.getElementById("photo") as HTMLInputElement;
        if (fileInput.files!.length > 0) {
          const photo: File = formData.get("photo") as File;
          const objectKey = `${uuid.v4()}${path.extname(photo.name)}`;
          const S3: AWS.S3 = new AWS.S3({ accessKeyId: AWS_CREDENTIALS.ACCESS_KEY_ID, secretAccessKey: AWS_CREDENTIALS.SECRET_ACCESS_KEY });
          await S3.putObject({ Bucket: S3_BUCKET, Key: objectKey, Body: photo, ACL: "public-read" }).promise();

          formData.delete("photo");
          formData.set("photo_url", `https://${S3_BUCKET}.s3.amazonaws.com/${objectKey}`);

        // Existing photo is unchanged.
        } else if (this.expense.photoURL && this.expense.photoURL !== "") {
          formData.set("photo_url", this.expense.photoURL);
        }

        const token: string = await firebase.auth().currentUser!.getIdToken();
        await axios.put(`${API_BASE_URL}/expenses/${this.id}`, formData, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        this.$router.push({ name: "Expense", params: { id: this.id } });

      } catch (error) {
        console.error(error);
      }
    },
  },
});
